module.exports = __webpack_public_path__ + "img/logo.253fa2e4.png";